import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { reduxForm, Field } from 'redux-form';
import PropTypes from 'prop-types';
import { submitUserInformation } from 'containers/DeviceSetupModal/device-setup-modal.saga';
import { InputField } from '../FormFields/InputField';
export var formConfig = {
  form: 'device-setup-tagline'
};
export var mapStateToProps = function mapStateToProps(state) {
  var userProfile = state.entities.userProfile.data.default;
  return {
    initialValues: {
      tagline: userProfile.tagline
    }
  };
};
export var DeviceSetupTaglineUnwrapped =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DeviceSetupTaglineUnwrapped, _React$Component);

  function DeviceSetupTaglineUnwrapped() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DeviceSetupTaglineUnwrapped);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DeviceSetupTaglineUnwrapped)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      var handleSubmit = _this.props.handleSubmit;
      handleSubmit(submitUserInformation)(event);
    });

    return _this;
  }

  _createClass(DeviceSetupTaglineUnwrapped, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          image = _this$props.image,
          username = _this$props.username,
          submitting = _this$props.submitting;
      return React.createElement("div", {
        className: "modal__device-tagline"
      }, React.createElement("div", {
        className: "modal__device-setup__top"
      }, React.createElement(FormattedMessage, {
        id: "device.profie-header",
        defaultMessage: "Profile",
        tagName: "h3"
      })), React.createElement("div", {
        className: "modal__device-setup__content"
      }, React.createElement("img", {
        src: image,
        alt: username,
        className: "modal__device-setup__profile-img"
      }), React.createElement("p", {
        className: "mt"
      }, username), React.createElement("form", {
        onSubmit: this.handleSubmit
      }, React.createElement(Field, {
        component: InputField,
        name: "tagline",
        inputClassNames: "modal__device-tagline__input mt mb++",
        inputAttributes: {
          maxLength: 20,
          placeholder: 'Enter a tagline or location'
        }
      }), React.createElement("button", {
        type: "submit",
        disabled: submitting,
        className: "bt bt--primary bt--width-md mb",
        key: "device.welcome.button"
      }, "Next"))));
    }
  }]);

  return DeviceSetupTaglineUnwrapped;
}(React.Component);
DeviceSetupTaglineUnwrapped.propTypes = {
  handleSubmit: PropTypes.func,
  image: PropTypes.string,
  username: PropTypes.string,
  submitting: PropTypes.bool
};
export var DeviceSetupTagline = connect(mapStateToProps)(reduxForm(formConfig)(DeviceSetupTaglineUnwrapped));